var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "show-more", class: { expanded: _vm.expanded } },
    [
      _c(
        "div",
        { staticClass: "show-more-container", style: "height: " + _vm.height },
        [
          _c(
            "div",
            { ref: "content", staticClass: "show-more-content" },
            [_vm._t("default")],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-button" }, [
        !_vm.expanded && _vm.has_more
          ? _c(
              "button",
              { staticClass: "btn btn-text", on: { click: _vm.showMore } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.lang.labels.show_more) +
                    "\n        "
                )
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }